import React from "react";

export default function RefreshIcon()
{
      return (
            <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M12.8337 7.00033C12.8337 10.2203 10.2203 12.8337 7.00033 12.8337C3.78033 12.8337 1.81449 9.59033 1.81449 9.59033M1.81449 9.59033H4.45116M1.81449 9.59033V12.507M1.16699 7.00033C1.16699 3.78033 3.75699 1.16699 7.00033 1.16699C10.8912 1.16699 12.8337 4.41033 12.8337 4.41033M12.8337 4.41033V1.49366M12.8337 4.41033H10.2437"
                        stroke="var(--color-icon-btn-action-header-drawer)"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                  />
            </svg>
      );
}
